export const getSortOrder = (state) => state?.ioc?.sortOrder;
export const getPagination = (state) => state?.ioc?.pagination;
export const getSorting = (state) => state?.ioc?.sorting;
export const getDistinct = (state) => state?.ioc?.distinct;
export const getFilters = (state) => state?.ioc?.filters;
export const getFilterProfile = (state) => state?.ioc?.filterProfile;
export const getIOC = (state) => state?.ioc?.scoreDetails;
export const getOpen = (state) => state?.sidebar?.open;
export const getFeedState = (state) => state?.ioc?.feedStateFilter ?? 'Feed';
export const getTag = (state) => state?.ioc?.tag;
